var topInfoBarInit;

(function ($) {
	const selectors = {
		wrapper: '[data-top-info-bar]',
		track: '[data-top-info-bar-track]',
		content: '[data-top-info-bar-content]'
	}

	topInfoBarInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new TopInfoBar(el);
		});
	}

	class TopInfoBar {
		constructor(element) {
			this.$wrapper = $(element);
			this.$track = this.$wrapper.find(selectors.track);
			this.$contents = this.$wrapper.find(selectors.content);

			this.init();
			this.bind();
		}

		init() {
			// Initial check
			this.checkWidth();

		}

		bind() {
			// Bind resize event
			$(window).on('resize', this.debounce(this.checkWidth.bind(this), 250));
		}

		checkWidth() {
			const wrapperWidth = this.$wrapper.width() - 16;
			const firstContentWidth = this.$contents.eq(0).outerWidth(true);

			// If first content span is wider than wrapper, enable animation
			if (firstContentWidth > wrapperWidth) {
				this.$track.addClass('is-animating');
			} else {
				this.$track.removeClass('is-animating');
			}
		}

		// Simple debounce function to prevent excessive updates
		debounce(func, wait) {
			let timeout;
			return function () {
				const context = this;
				const args = arguments;
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					func.apply(context, args);
				}, wait);
			};
		}
	}

})(jQuery);

export default topInfoBarInit;